export const trackerArticleId = 170;
